// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__-UlgK","alertIcon":"ConfirmModal_alertIcon__2jN7f"};